import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { MessageCircle, Code } from 'lucide-react'

interface ContactSectionProps {
  className?: string
}

const ContactSection: React.FC<ContactSectionProps> = ({ className }) => {
  return (
    <div className={className}>
      <Card variant="elevated" className="hover:border-primary-500/30 transition-colors">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-primary-500/20 flex items-center justify-center mx-auto mb-4 rounded-full">
            <MessageCircle size={32} className="text-primary-500" />
          </div>
          <h2 className="text-2xl font-bold text-[var(--foreground)] mb-4">Ready to Get Started?</h2>
          <p className="text-[var(--muted-foreground)] mb-6 max-w-2xl mx-auto">
            Join our network of official partners and start generating additional revenue from your existing clients today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="inline-flex items-center gap-2">
              <MessageCircle size={16} />
              Start Partnership
            </Button>
            <Button variant="outline" size="lg" className="inline-flex items-center gap-2">
              <Code size={16} />
              Request API Access
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default ContactSection 